import { IHealthRecord, IHealthSearch } from "@interfaces";
import axiosClient from "./axiosClient";

export const healthApi = {
  list: (params: IHealthSearch) => {
    const url = "/repoductive-health";
    return axiosClient.get(url,{ params });
  },
  create: (params: IHealthRecord) => {
    const url = "/repoductive-health/create";
    return axiosClient.post(url, params);
  },
  detail: (id: string) => {
    const url = `/repoductive-health/get/${id}`;
    return axiosClient.get(url);
  },
  update: (params: IHealthRecord, id: string) => {
    const url = `/repoductive-health/update/${id}`;
    return axiosClient.put(url, params);
  },
  export: (params: IHealthSearch) => {
    const url = `/repoductive-health/export-records`;
    return axiosClient.post(url, params );
  },
  clients: (params: IHealthSearch) => {
    const url = `/repoductive-health/srhr-clients`;
    return axiosClient.get(url, {params} );
  }      
};
